module.exports = __webpack_public_path__ + "img/piece-locked-6.f8f4fae8.svg";